import { render, staticRenderFns } from "./Today.vue?vue&type=template&id=6dd67d6a&scoped=true&"
import script from "./Today.vue?vue&type=script&lang=ts&"
export * from "./Today.vue?vue&type=script&lang=ts&"
import style0 from "./Today.vue?vue&type=style&index=0&id=6dd67d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd67d6a",
  null
  
)

export default component.exports